import styled from 'styled-components'
import { Drawer } from 'antd'

const WrapChildren = styled.div`
  display: flex;
  flex: 1;
  overflow: auto;
`

const WrapContent = styled.div`
  overflow-x: hidden;
  padding: 10px 16px;
  width: 100%;
`
const WrapDrawer = styled(Drawer)`
  .ant-drawer-wrapper-body {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
`

const WrapFooter = styled.div`
  border-top: 1px solid rgb(233, 233, 233);
  padding: 10px 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  > button {
    margin-left: 0.5rem;
  }
`

export { WrapChildren, WrapContent, WrapDrawer, WrapFooter }
